import { render, staticRenderFns } from "./ProjectSettingsPanels.vue?vue&type=template&id=748b07cd&"
import script from "./ProjectSettingsPanels.vue?vue&type=script&lang=js&"
export * from "./ProjectSettingsPanels.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports